import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { CORE_QUERY_KEYS as INVENTORY_QUERY_KEYS } from 'app/hooks/data/core/extranet/inventory';
import type { CalendarPeriod } from 'app/typings/core/extranet/inventory/calendar';
import type { CalendarSeriesScope } from 'app/typings/core/extranet/inventory/enums/CalendarSeriesScope';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useDeleteSeries(
  hotelId?: number,
  calendarId?: number,
  period?: CalendarPeriod
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      seriesId,
      scope,
      date,
    }: {
      seriesId: number;
      scope: CalendarSeriesScope;
      date: string;
    }) =>
      hotelId && calendarId
        ? (apiMutation('DELETE', {
            path: ENDPOINTS.deleteSeries,
            params: {
              hotelId: hotelId.toString(),
              calendarId: calendarId.toString(),
              seriesId: seriesId.toString(),
            },
            queryParams: {
              startDate: period?.startDate,
              endDate: period?.endDate,
              scope,
              date,
            },
          }) as Promise<void>)
        : Promise.reject(null),
    onSuccess: () => {
      message.success('Recurring availability successfully deleted');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.calendar, { hotelId, calendarId }],
      });

      queryClient.invalidateQueries({
        queryKey: [INVENTORY_QUERY_KEYS.inventory, { hotelId }],
      });
    },
    onError: () => {
      message.error('Failed to delete recurring availability.');
    },
  });
}
